import { Tooltip } from "primereact/tooltip";
import { LanguageProficiencyConstants } from "../../../constants/language-proficiency";
import { getCountryCodeFromLanguage, getLanguageName } from "../../../helpers/countryHelper";
import { getCurrentUserFromLocalStorage, getI18nLanguageFromLocalStorage } from "../../../helpers/localStorageHelper";
import { getLanguageDisplayName } from "../../../helpers/languageHelper";
import HeartButton from "./common/HeartButton";
import LanguageFlag from "./common/LanguageFlag";
import LanguageTag from "./common/LanguageTag";
import StarRating from "./common/StarRating";
import { useState } from "react";
import { useEffect } from "react";
import formatRating from "../../../helpers/formatRating";
const NewTrainerHeaderItem = ({
  source,
  onViewMoreClick,
  props,
  onFavoriteClick,
  showMoreInformation = true,
  displayNameClassName = "keduall-typography text-default-txt heading-h5-semibold-600",
  enableTagsCollapse = false,
  maximumTagItem = 9,
  maximumLanguageItem = 2,
}) => {
  const currentUser = getCurrentUserFromLocalStorage();

  const [showAllTags, setShowAllTags] = useState(false);
  const [showAllLangs, setShowAllLangs] = useState(false);

  const [language, setLanguage] = useState("");

  useEffect(() => {
    const language = getI18nLanguageFromLocalStorage();
    setLanguage(language);
  }, []);

  const getTrainerLevelsBadge = (code) => {
    return LanguageProficiencyConstants[code]?.badge || "";
  };

  const renderTags = () => {
    const tags = source.trainerTags ?? [];
    const hasMoreTags = tags.length > maximumTagItem;

    return (
      <>
        {tags.slice(0, showAllTags ? undefined : maximumTagItem)
          .map((trainerTag, index) => (
            <div
              key={`level-${index}`}
              className="flex align-items-center gap-2"
            >
              <LanguageTag
                text={trainerTag.description}
                styleClass={`keduall-typography text-12-medium-500 keduall-badge keduall-badge-primary-button`}
              />
            </div>
          ))}
        
        {hasMoreTags && !showAllTags && (
          <div 
            className={`flex align-items-center gap-2 ${enableTagsCollapse ? 'cursor-pointer' : ''}`} 
            key="extra-tags"
            onClick={(e) => {
              e.stopPropagation();
              if (enableTagsCollapse && (e.target === e.currentTarget || e.currentTarget.contains(e.target))) {
                setShowAllTags(true);
              }
            }}
          >
            <LanguageTag
              text={`+${tags.length - maximumTagItem}`}
              styleClass={`keduall-typography text-12-medium-500 keduall-badge keduall-badge-extra-button`}
            />
          </div>
        )}

        {showAllTags && enableTagsCollapse && (
          <div 
            className="flex align-items-center gap-2 cursor-pointer"
            onClick={(e) => {
              e.stopPropagation();
              if (e.target === e.currentTarget || e.currentTarget.contains(e.target)) {
                setShowAllTags(false);
              }
            }}
          >
            <LanguageTag
              text={props.btnReadLess}
              styleClass={`keduall-typography text-12-medium-500 keduall-badge keduall-badge-extra-button`}
            />
          </div>
        )}
      </>
    );
  };

  const renderLanguages = () => {
    const langs = source.trainerLanguages ?? [];
    const hasMoreLangs = langs.length > maximumLanguageItem;

    return (
      <>
        {langs.slice(0, showAllLangs ? undefined : maximumLanguageItem)
          .map((lang, index) => (
            <>
              <div
                key={`lang-${index}`}
                className="flex align-items-center gap-1"
              >
                <span
                  className={` ${getCountryCodeFromLanguage(lang.languageCode)}`}
                >
                  {getLanguageName(lang.languageCode)}
                </span>
                <span
                  className={`${getCountryCodeFromLanguage(lang.languageCode)}-${index}`}
                >
                  ({lang.proficiencyDescription})
                </span>
              </div>
              {index !== source.trainerLanguages.length - 1 && <span className="mr-2">,</span>}
              
            </>
          ))}
        
        {hasMoreLangs && !showAllLangs && (
          <div 
            className={`flex align-items-center gap-2 cursor-pointer`} 
            key="extra-tags"
            onClick={(e) => {
              e.stopPropagation();
              if (e.target === e.currentTarget || e.currentTarget.contains(e.target)) {
                setShowAllLangs(true);
              }
            }}
          >
            +{langs.length - maximumLanguageItem}
          </div>
        )}
      </>
    );
  };

  return (
    <>
      <div className="flex-shrink-0">
        <img
          src={source.profilePicture ?? props.defaultProfilePicture}
          alt={`${source.displayName} profile`}
          className="avatar w-11rem h-11rem object-fit--cover border-circle"
        />
      </div>
      <div className="flex flex-column flex-1 min-w-0 w-auto">
        <div className="flex flex-column gap-2 trainer-header-item">
          <div className="flex align-items-center gap-3">
            <h4 className={`${displayNameClassName} hover:underline cursor-pointer`}               
                onClick={() => {
                  if (source?.publicId) {
                    window.location.href = `/${language}/real-time-lectures/${source.publicId}`;
                  }
                  }}>
              {source.nickName || source.displayName}                   
            </h4>
            <LanguageFlag
              code={source.country}
              className={"keduall-icon keduall-typography text-14-medium-500 flag-rectangle-country flex-shrink-0"}
            />
            {!!currentUser && (
              <HeartButton
                likedClick={onFavoriteClick}
                liked={source.isFavorite}
              ></HeartButton>
            )}
          </div>
          <div className="flex align-items-center gap-1">
            <StarRating rating={source.rating} />
            <span className="ml-2">({formatRating(source.rating)})</span>
          </div>
          <div className="flex flex-wrap keduall-typography text-secondary-txt gap-1">
            <span className="pi pi-language font-bold"></span> {props.languagesSpoken} {renderLanguages()}
          </div>
          <div className="flex flex-wrap gap-2">
            {renderTags()}
          </div>

          {showMoreInformation && (
            <>
              <div className="keduall-text two-row-ellipsis keduall-typography text-14-normal-500 text-dark-txt mt-2">
                {source.introductionVideoDescription}
              </div>
              <div className="mt-2">
                <span
                  className="cursor-pointer underline-button keduall-typography text-16-semibold-600 text-default-txt"
                  onClick={onViewMoreClick}
                >
                  {props.viewMoreLabel}
                </span>
              </div>
            </>
          )}
        </div>
      </div>
    </>
  );
};

export default NewTrainerHeaderItem;
